module.exports = __webpack_public_path__ + "img/craftBannerBathMobile.6cf2845.webp";